import { Outlet, Navigate } from "react-router-dom";


function ProtectedRouter() {
    const userToken = localStorage.getItem("crymadx")

    return userToken ? (
        <Navigate to={"/home"} />
    ) : (
        <Outlet />
    )
}

export default ProtectedRouter;